import "./Pre-Prompts-Modal.scss"



const PrePromptsModal = ({ togglePromptModal, preDefinedPromptHanlderClick }) => {



    const preDefinedprompts = [
        {
            title: "Time series analysis",
            reportType: "timeseries",
            options: [
                { prompt: "Can you generate rdr for anomalies/issues found", key: "Generate rdr report" },
                { prompt: "Can you generate a chart for anomalies/issues found", key: "Generate a chart" },
                { prompt: "Are there any patterns or correlations that can be observed between properties?" },
                { prompt: "I am new technician and still learning, based on available timeseries data, can you please suggest how can I inspect this equipment, please provide potential prompts, I need to make sure if the system functions properly or not." }
            ]
        },
        {
            title: "Analytics analysis",
            reportType: "analytics",
            options: [
                {
                    prompt: `Please analyze statistical data of all the analytics results and provide detailed report including various sections with title. At the end provide the summary of count of each result type, include % as well.
\n Note: Ur -  Upper Red Limit, and so on. IVD - Invalid Data, ISD is Insufficient Data, G is Green.` },
                { prompt: "If there are any Red results, do a detailed root cause analysis and provide the reasons for the failure. Also provide potential prompts as description in a table with links (right side) in title for further investigation based on your analysis to make sure the equipment is functioning properly." }
            ]
        }
    ]

    return (
        <div className="pre-prompt-modal-container">
            <div className="pre-prompt-content">
                <header>
                    <p>Example Prompts</p>
                    <span onClick={togglePromptModal} className="close-button">X</span>
                </header>
                <div>
                    {preDefinedprompts.map((x, i) => {
                        return (
                            <div key={i} className="prompts-content">
                                <div className="title">{x?.title}</div>
                                <ul className="options">
                                    {x?.options.map((y, j) => {
                                        return (
                                            <li key={j} className="prompt-option"><span onClick={() => {
                                                preDefinedPromptHanlderClick(x?.reportType, y?.prompt)
                                            }}>{y?.key || y?.prompt}</span></li>
                                        )
                                    })}
                                </ul>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}


export default PrePromptsModal